import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ImageDisplayService } from './image-display.service';

@Component({
    selector: 'app-image-display', templateUrl: './image-display.component.html', styleUrls: ['./image-display.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ImageDisplayComponent implements OnInit {
    imageSrc: string;

    constructor(
        public imageDisplayService: ImageDisplayService
    ) {}

    ngOnInit() {
        this.imageDisplayService.getImage().subscribe(data => {
            this.imageSrc = data;
        });
    }

    close() {
        this.imageDisplayService.setImage(null)
    }
}
